// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__sltOb","avatar":"styles_avatar__zT8Ix","edit-icon":"styles_edit-icon__g39Z2"};